import classnames from 'classnames/bind'
import React from 'react'

import Cta, { CtaProps } from '~/components/Cta'
import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import { ReactComponent as CheckboxIcon } from './checkbox.svg'
import css from './styles.module.scss'

const cx = classnames.bind(css)

interface FeatureProps {
  title?: RichTextBlock[]
  text?: RichTextBlock[]
}

interface PricingProps {
  title?: RichTextBlock[]
  text?: RichTextBlock[]
}

export interface PricingsProps {
  className?: string
  title?: RichTextBlock[]
  text?: RichTextBlock[]
  subtitle?: RichTextBlock[]
  pricings?: PricingsProps[]
  features?: FeatureProps[]
}

function Pricings({
  className,
  text,
  title,
  subtitle,
  pricings,
  features,
}: PricingsProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const titleStyle = useStyle({ textPreset: 'title-section-page' })
  const textStyle = useStyle({ textPreset: 'text-paragraph' })
  const subtitleStyle = useStyle({ textPreset: 'title-heading-4' })

  const pricingTitleStyle = useStyle({ textPreset: 'title-heading-5' })
  const pricingTextStyle = useStyle({ textPreset: 'text-body' })

  const featureTitleStyle = useStyle({ textPreset: 'text-paragraph-body' })
  const featureTextStyle = useStyle({ textPreset: 'title-heading-6' })

  return (
    <div className={cx(css.Pricings, className)}>
      <div className={gridStyle}>
        <div className={css.content}>
          {title && (
            <RichText className={cx(css.title, titleStyle)} render={title} />
          )}
          {text && (
            <RichText className={cx(css.text, textStyle)} render={text} />
          )}
          <div className={css.pricings}>
            {pricings?.map(({ title, text }, index) => (
              <div
                className={cx(css.pricing, { isOdd: index % 2 !== 0 })}
                style={{ width: `${100 / pricings?.length}%` }}
                key={`pricings${index}`}>
                {title && (
                  <RichText
                    className={cx(css.pricingTitle, pricingTitleStyle)}
                    render={title}
                  />
                )}
                {text && (
                  <RichText
                    className={cx(css.pricingText, pricingTextStyle)}
                    render={text}
                  />
                )}
              </div>
            ))}
          </div>
          {subtitle && (
            <RichText
              className={cx(css.subtitle, subtitleStyle)}
              render={subtitle}
            />
          )}

          <div className={css.features}>
            {features?.map(({ title, text }, index) => (
              <div
                className={cx(css.feature, { isOdd: index % 2 !== 0 })}
                key={`feature${index}`}>
                {title && (
                  <RichText
                    className={cx(
                      css.featureTitle,
                      featureTitleStyle,
                      css.left,
                    )}
                    render={title}
                  />
                )}
                <div className={css.right}>
                  {text ? (
                    <div className={cx(css.featureText, featureTextStyle)}>
                      {text}
                    </div>
                  ) : (
                    <CheckboxIcon className={cx(css.icon)} />
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}

Pricings.defaultProps = {}

export default Pricings
